import {EventEmitter, Injectable} from '@angular/core';
import {IPlatformToolHandler} from '@shared/components/platform-tool/platform-tool-container/platform-tool-component';
import {InvalidateSubject} from '@shared/helpers/invalidate.subject';
import {MagicLinkModel, TabModel} from '@shared/models/platform-tool-models';
import {PlatformCommand} from '@shared/commands/command-base';
import {Subject} from 'rxjs';


@Injectable({
  providedIn: 'root',
})

export class PlatformToolItcDesktopHandler implements IPlatformToolHandler {
  invalidateSubject: InvalidateSubject;
  magicLinkModel: MagicLinkModel;
  magicLinkModelValueChanged: EventEmitter<any>;
  ngUnsubscribe = new Subject<void>();

  destroy(): void {
    this.invalidateSubject.close();
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  executeCommand(command: PlatformCommand) {
  }

  setSelectedTab(selectedTab: TabModel): void {
  }

  valueChanged($event) {
  }
}
